import React from 'react'
import styled from 'styled-components'

import findByLayoutId from '../../utils/findByLayoutId.js'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(420px, 35%) 80px minmax(calc(65% - 80px), 1fr);
  grid-template-areas:
  "header alphabet main"
  "content alphabet main"
  "cta cta cta";
  height: 100%;
  grid-template-rows: minmax(80px, 151px) 1fr 100px;
`

const Main = styled.div`
  grid-area: main;
  height: 100%;
  position: relative;
`

const Header = styled.header`
  grid-area: header;
`

const Content = styled.div`
  grid-area: content;
  min-height: 10em;
  overflow-y: auto;
  scroll-behavior: smooth;
`

const Navigation = styled.div`
  grid-area: cta;
`

const Alphabet = styled.div`
  grid-area: alphabet;
  width: 80px;
  min-height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`

export default function SearchDirectoryLayout ({ app, children }) {
  const header = findByLayoutId('header', children, app)
  const content = findByLayoutId('content', children, app)
  const main = findByLayoutId('main', children, app)
  const alphabet = findByLayoutId('alphabet', children, app)
  const navigation = findByLayoutId('navigation', children, app)
  return <Wrapper>
    <Header>{header}</Header>
    <Content>{content}</Content>
    <Alphabet>{alphabet}</Alphabet>
    <Main>{main}</Main>
    <Navigation>{navigation}</Navigation>
  </Wrapper>
}
